import React from "react";
import { Table } from "antd";
import CountryTableCell from "./CountryTableCell";

const { Column } = Table;

const TopCountriesTable = ({ dataSource }) => {
  return (
    <Table dataSource={dataSource} pagination={false} size="small" data-cy="top-countries-table">
      <Column title="#" dataIndex="key" align="left" width={40} />
      <Column
        className="no-wrap"
        title="Country"
        dataIndex="country"
        render={(_, record) => <CountryTableCell code={record["country_code"]} name={record["country"]} />}
      />
      <Column
        className="no-wrap al-right"
        title="Domains"
        dataIndex="domains_num"
        render={(_, record) => parseInt(record["domains_num"]).toLocaleString()}
      />
      <Column
        className="no-wrap al-right"
        title="Backlinks"
        dataIndex="backlinks_num"
        render={(_, record) => parseInt(record["backlinks_num"]).toLocaleString()}
      />
    </Table>
  );
};

export default TopCountriesTable;
